module.exports = __webpack_public_path__ + "static/industry-img-3cb26de301188c576d491679deaa4632.png";